import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import FAQ from "@/components/FAQ";
import Location from "@/components/Location";
import StickyBar from "@/components/StickyBar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import ContentStudio from "@/components/ContentStudio";

function App() {
    const [studioOpen, setStudioOpen] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="grain bg-[#0B0F17] text-white" data-testid="landing-page">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <Gallery />
                <FAQ />
                <Location />
            </main>
            <Footer onOpenStudio={() => setStudioOpen(true)} />
            <StickyBar />
            <ChatWidget />
            <ContentStudio open={studioOpen} onClose={() => setStudioOpen(false)} />
        </div>
    );
}

export default App;
